import React from "react";
import pdfIcon from '../images/pdf.svg';
import pdf from '../media/MADRS.pdf';

function ExplorerPage(props) {

	return (
		<p style={{textAlign:"center", margin:"auto"}}>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			Den här tjänsten fungerar inte med webbläsaren Internet Explorer. Vänligen använd Chrome, Edge eller FireFox.
		</p>
	);
}


export default ExplorerPage;



// WEBPACK FOOTER //
// ./src/pages/explorerPage.js